import type { PedigreeTypePresentation } from '@application/types';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { GenderEnum, ParentTypeEnum } from '@gql/graphql';

export const GENDER_ICON: Record<GenderEnum, IconProp> = {
  [GenderEnum.F]: 'venus',
  [GenderEnum.M]: 'mars',
  [GenderEnum.OTHER]: 'times',
};

export const PARENT_TYPE_ICON: Record<ParentTypeEnum, IconProp> = {
  [ParentTypeEnum.MOTHER]: 'venus',
  [ParentTypeEnum.FATHER]: 'mars',
};

export const PEDIGREE_TYPE_ICON: Record<PedigreeTypePresentation, IconProp> = {
  FCI: 'globe',
  OTHER: 'ellipsis-h',
  NONE: 'ban',
};

export const BORN_TYPE_ICON = (born: boolean): IconProp =>
  born ? 'baby-carriage' : 'hourglass-half';

export const BINARY_ICON = (value: boolean): IconProp => (value ? 'check' : 'ban');
